const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class CtaCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    let gridGap = 0

    if (this.getAttribute('data-slide-gap') === 'true') {
      gridGap = 10

      if (window.BAO.MediaBreakpoints.isSm) {
        gridGap = 20
      }
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.05,
          spacing: gridGap,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 1.5,
              spacing: gridGap,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 1.75,
              spacing: gridGap,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 2.5,
              spacing: gridGap,
            },
          },
          '(min-width: 1441px)': {
            slides: {
              perView: 3,
              spacing: gridGap,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
